<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-client-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.client.new') }}</h4>
        </template>
        <template v-slot:body>
            <div class="form-horizontal">

                <div class="form-group" v-show="errorMessage">
                    <div class="alert alert-danger" style="margin: 0 10px;">
                        {{errorMessage}}
                    </div>
                </div>
                <div class="form-group">
                    <label for="first_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.first_name') }}*</label>
                    <div class="col-xs-12 col-md-8">
                        <input class="form-control"
                               type="text"
                               :placeholder="$t('components.client.placeholder_first_name')"
                               name="first_name_client_modal"
                               id="first_name_client_modal"
                               v-model="newClientFirstName">
                    </div>
                </div>
                <div class="form-group">
                    <label for="last_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.last_name') }}*</label>
                    <div class="col-xs-12 col-md-8">
                        <input class="form-control"
                               type="text"
                               :placeholder="$t('components.client.placeholder_last_name')"
                               id="last_name_client_modal"
                               name="last_name_client_modal"
                               v-model="newClientLastName">
                    </div>
                </div>
                <div class="form-group">
                    <label for="phone_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.phone') }}*</label>
                    <div class="col-xs-12 col-md-8">
                        <VuePhoneNumberInput
                                no-validator-state
                                @update="updatePhoneNumber"
                                :default-country-code="country"
                                v-model="newClientPhoneNumber"
                                :translations="translations"
                                id="phone_name_client_modal"></VuePhoneNumberInput>
                    </div>
                </div>
                <div class="form-group">
                    <label for="email_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.email') }}*</label>
                    <div class="col-xs-12 col-md-8">
                        <input class="form-control"
                               type="email"
                               :placeholder="$t('components.client.placeholder_email')"
                               id="email_name_client_modal"
                               name="email_name_client_modal"
                               v-model="newClientEmail">
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewCustomer(newClientFirstName, newClientLastName, newClientPhoneNumberInternational, newClientEmail)">
                <i class="las la-check"></i>
                {{ $t('components.client.create') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import {createClient} from "../../api";
    import ModalContainer from "./ModalContainer";
    import {Utils} from "../../common/utils";
    export default {
        name: "AddClientModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                newClientPhoneNumberInternational: "",
                newClientPhoneNumber: "",
                newClientFirstName: "",
                newClientLastName: "",
                newClientEmail: "",
                errorMessage: "",
                translations: Utils.getTranslationsPhoneField(),
                country: Utils.getDefaultCountry()
            }
        },
        components: {ModalContainer, VuePhoneNumberInput},
        methods: {
            async createNewCustomer(firstName, lastName, phoneNumber, email) {
                this.loading = true;
                try {
                    const resultClient = await createClient(firstName, lastName, phoneNumber, email);
                    this.loading = false;
                    this.$emit('close-client-modal');
                    this.$nextTick(() => {
                        this.$nextTick(() => {
                            this.$router.push({name: 'client_detail', params: {id: resultClient.id}});
                        });
                    });

                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            }, updatePhoneNumber(result) {
                this.newClientPhoneNumberInternational = result.formatInternational;
            }
        }
    };
</script>